import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    webInfo: {
      name: "意刻",
      logo: "",
      title: "",
      desc: "",
    },
    menuOpen: localStorage.getItem("mm-menuOpen") == "false" ? false : true,
    userInfo: {},
    islogin: false,
    uploadInfo: {
      qtype: 0,
    },
    searchInfo: {
      question: "",
      show: false,
      datas: [],
    },
  },
  getters: {
    getMenuOpen: (state) => state.menuOpen,
    getUserInfo: (state) => state.userInfo,
    getWebInfo: (state) => state.webInfo,
    getIsLogin: (state) => state.islogin,
    getQtype: (state) => state.uploadInfo.qtype,
    getSearchInfo: (state) => state.searchInfo,
  },
  mutations: {
    // 更新菜单展开/ 关闭状态
    changeMenuOpen(state, payload) {
      localStorage.setItem("mm-menuOpen", payload);
      state.menuOpen = payload;
    },
    // 更新用户token
    upUserInfo(state, payload) {
      state.islogin = true;
      state.userInfo = { ...state.userInfo, ...payload };
    },
    upResult(state, payload) {
      state.searchInfo = { ...state.searchInfo, ...payload };
    },
    changeQtype(state, payload) {
      state.uploadInfo.qtype = payload;
    },
  },
  actions: {},
  modules: {},
});
export default store;
